<template>
  <div class="monthly-unit-chart">
    <h6 class="monthly-unit-chart__title">Monthly Unit Trend</h6>
    <div v-if="loading" class="text-center py-3"><i class="fa fa-spinner fa-spin"></i></div>
    <div v-else>
      <div class="chart-bars" v-if="chartData.length > 0">
        <div v-for="item in chartData" :key="item.label" class="chart-bar-group">
          <div class="chart-bar-wrapper">
            <div
              class="chart-bar"
              :style="{ height: getBarHeight(item.units) + '%' }"
              :title="`${item.units} units`"
            ></div>
          </div>
          <span class="chart-bar-label">{{ item.label }}</span>
          <span class="chart-bar-value">{{ item.units }}</span>
        </div>
      </div>
      <div v-else class="text-center" style="color: #b3a6a6; font-size: 0.85rem;">
        No data available.
      </div>
    </div>
  </div>
</template>

<script>
import { reportsService } from "@/serviceHandlers/reportsService";
import dayjs from "dayjs";

export default {
  name: "MonthlyUnitChart",
  props: {
    clientId: { type: Number, required: true },
  },
  data() {
    return {
      chartData: [],
      loading: false,
      maxUnits: 1,
    };
  },
  watch: {
    clientId: {
      immediate: true,
      handler(val) { if (val) this.fetch(); },
    },
  },
  methods: {
    async fetch() {
      this.loading = true;
      try {
        const results = [];
        const now = dayjs();
        // Fetch last 6 months
        for (let i = 5; i >= 0; i--) {
          const target = now.subtract(i, "month");
          try {
            const data = await reportsService.getMonthlyUnitsReport({
              month: target.month() + 1,
              year: target.year(),
              clientId: this.clientId,
            });
            const clientRow = (data.data || []).find((r) => r.clientId === this.clientId);
            results.push({
              label: target.format("MMM"),
              units: clientRow ? clientRow.totalUnits : 0,
            });
          } catch {
            results.push({ label: target.format("MMM"), units: 0 });
          }
        }
        this.chartData = results;
        this.maxUnits = Math.max(1, ...results.map((r) => r.units));
      } catch {
        this.chartData = [];
      } finally {
        this.loading = false;
      }
    },
    getBarHeight(units) {
      return Math.max(2, (units / this.maxUnits) * 100);
    },
  },
};
</script>

<style scoped>
.monthly-unit-chart { background: rgba(37, 55, 65, 0.95); border: 1px solid rgba(255, 255, 255, 0.1); border-radius: 8px; padding: 1rem; }
.monthly-unit-chart__title { color: #fff; margin-bottom: 1rem; }
.chart-bars { display: flex; gap: 0.75rem; align-items: flex-end; height: 150px; }
.chart-bar-group { flex: 1; display: flex; flex-direction: column; align-items: center; }
.chart-bar-wrapper { flex: 1; width: 100%; display: flex; align-items: flex-end; justify-content: center; }
.chart-bar { width: 60%; background: #447DF7; border-radius: 3px 3px 0 0; min-height: 2px; transition: height 0.3s; }
.chart-bar-label { color: #b3a6a6; font-size: 0.75rem; margin-top: 0.25rem; }
.chart-bar-value { color: #e0e0e0; font-size: 0.75rem; font-weight: 600; }
</style>
